import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import { findUser } from '../actions/users';
import { findSimoDevice } from '../actions/simoDevices';

import withSimoDevice from './withSimoDevice';

const simoDevicePage = (DecoratedComponent) => {
  class SimoDevicePage extends Component {
    state = {
      loading: false,
    };

    componentDidMount() {
      this.fetchDevice();
    }

    componentDidUpdate(oldProps) {
      if (oldProps.simoDeviceId !== this.props.simoDeviceId) {
        this.fetchDevice();
      }
    }

    fetchDevice = async () => {
      const { findSimoDevice, simoDeviceId, findUser } = this.props;
      try {
        this.setState({ loading: true });
        const res = await findSimoDevice(simoDeviceId);
        if (res && res.user_profile) {
          await findUser(res.user_profile);
        }
      } catch (e) {
        toast.error('Failed to load simo device');
      } finally {
        this.setState({ loading: false });
      }
    };

    render() {
      const { children, findSub, findUser, ...props } = this.props;
      const { loading } = this.state;

      return React.createElement(
        DecoratedComponent,
        {
          simoDeviceLoading: loading,
          ...props,
        },
        children,
      );
    }
  }

  const mapDispatchToProps = {
    findSimoDevice,
    findUser,
  };

  SimoDevicePage = withSimoDevice(
    connect(null, mapDispatchToProps)(SimoDevicePage),
  );

  return SimoDevicePage;
};

export default simoDevicePage;
